import { useContext, useEffect, useState } from 'react';
import { Button, Col, Form, Modal, Row, Tab, Tabs } from 'react-bootstrap';
import Axios from 'axios';
import DashboardContext from 'Context';
import toaster from 'helper/toaster';
import { Alert, Space, Spin } from 'antd';
import InputControlMulti from 'components/inputs/InputControlMulti';

/**
 * این کامپوننت برای نمایش مدال نظر سنجی است
 */
const ModalUpdateSurvey = ({
  id,
  survey,
  showitem,
  type = 0,
  isFromApp,
  handeldeleteitem,
  businessType = 0,
  handleCloseMoudal,
}) => {
  const { urldashboard, authentication } = useContext(DashboardContext);
  const [dataFech, setdataFech] = useState({});
  const [rate, setRate] = useState(0);
  const [dataForm, setDataForm] = useState({ id });
  const [Loading, setLoading] = useState(false);
  const [submitIsLoading, setSubmitIsLoading] = useState(false);
  const [pointData, setPointData] = useState({
    positivePoints: [],
    negativePoints: [],
  });

  const dataFeching = async () => {
    setLoading(true);
    try {
      const res = await Axios.get(
        `${urldashboard}/workerOrderSchedule/updateSurvey/${id}`,
        {
          headers: {
            Authorization: authentication,
            'content-type': 'application/json; charset=utf-8',
          },
        }
      );

      const data = await res.data.data;

      setdataFech(data);
      setDataForm(data);
      setRate(data.star);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error.message === 'Network Error') {
        toaster.error('اینترنت قطع است لطفا وضعیت اینترنت را بررسی کنید.');
        handleCloseMoudal();
      } else {
        handleCloseMoudal();
        toaster.error(error?.response?.data?.message);
      }
    }
  };

  useEffect(() => {
    if (businessType !== 1) dataFeching();
    return () => {};
  }, []);

  const ratingMeter = businessType
    ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    : [1, 2, 3, 4, 5];

  const handleStar = (number) => {
    setRate(number);
    setDataForm({ ...dataForm, star: number });
  };

  const handelValue = (event) => {
    if (event.target.checked) {
      const oldarry = dataForm.surveyTitleIds ? dataForm.surveyTitleIds : [];

      setDataForm({
        ...dataForm,
        surveyTitleIds: [...oldarry, event.target.name],
      });
    } else {
      const isfilter = dataForm.surveyTitleIds.filter(
        (item) => item !== event.target.name
      );

      setDataForm({ ...dataForm, surveyTitleIds: isfilter });
    }
  };

  const sendData = async () => {
    delete dataForm?.surveyTitleHeaders;

    const command = {
      ...dataForm,
      workerOrderScheduleId: dataForm?.id,
      disciplineIds: [
        ...pointData?.positivePoints,
        ...pointData?.negativePoints,
      ],
    };

    delete command?.id;
    delete command?.surveyTitleIds;

    const expertCommand = {
      ...command,
      workerId: id,
    };

    const customerCommand = {
      ...command,
      customerId: id,
    };

    delete expertCommand?.id;
    delete expertCommand?.workerOrderScheduleId;
    delete customerCommand?.id;
    delete customerCommand?.workerOrderScheduleId;

    let url =
      businessType === 0
        ? `${urldashboard}/workerOrderSchedule/updateSurvey`
        : type === 7
        ? `${urldashboard}/expertWorkerSurvey/create`
        : type === 8
        ? `${urldashboard}/expertCustomerSurvey/create`
        : `${urldashboard}/workerOrderSurvey/create`;
    try {
      const res =
        businessType === 0
          ? await Axios.put(url, JSON.stringify(dataForm), {
              headers: {
                Authorization: authentication,
                'content-type': 'application/json; charset=utf-8',
              },
            })
          : type === 7
          ? await Axios.post(url, JSON.stringify(expertCommand), {
              headers: {
                Authorization: authentication,
                'content-type': 'application/json; charset=utf-8',
              },
            })
          : type === 8
          ? await Axios.post(url, JSON.stringify(customerCommand), {
              headers: {
                Authorization: authentication,
                'content-type': 'application/json; charset=utf-8',
              },
            })
          : await Axios.post(url, JSON.stringify(command), {
              headers: {
                Authorization: authentication,
                'content-type': 'application/json; charset=utf-8',
              },
            });

      const data = await res.data;
      toaster.success(data?.message);
      setPointData({
        positivePoints: [],
        negativePoints: [],
      });
      handleCloseMoudal();
      handeldeleteitem();
    } catch (error) {
      if (error.message === 'Network Error') {
        toaster.error('اینترنت قطع است لطفا وضعیت اینترنت را بررسی کنید');
        setSubmitIsLoading(false);
      } else {
        setSubmitIsLoading(false);
        toaster.error(error?.response?.data?.message);
      }
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitIsLoading(true);
    if (dataForm?.star === undefined || dataForm?.star === null) {
      toaster.error('لطفا ستاره انتخاب کنید');
      setSubmitIsLoading(false);
    } else {
      sendData();
    }
  };

  return (
    <Modal
      show={showitem}
      onHide={() => {
        setPointData({
          positivePoints: [],
          negativePoints: [],
        });
        handleCloseMoudal();
      }}
    >
      <Modal.Header>
        <Modal.Title>ثبت نظرسنجی</Modal.Title>
        <i
          className='fa fa-times mr-auto'
          style={{ fontSize: '16px', cursor: 'pointer' }}
          onClick={() => {
            setPointData({
              positivePoints: [],
              negativePoints: [],
            });
            handleCloseMoudal();
          }}
          aria-hidden='true'
        ></i>
      </Modal.Header>
      <Modal.Body>
        {Loading ? (
          <Spin />
        ) : (
          <Row>
            {isFromApp && (
              <Col>
                <Alert
                  message='مشتری از طریق اپلیکیشن سفارش را ثبت کرده است.'
                  type='info'
                />
              </Col>
            )}
            {survey > 0 && (
              <Col>
                <Alert
                  message='نظرسنجی برای این نیرو ثبت شده است.'
                  type='info'
                />
              </Col>
            )}
            <Col
              lg='12'
              md='12'
              sm='12'
              className='d-flex align-content-center text-center justify-content-center'
              style={{ margin: '1rem 0', direction: 'ltr' }}
            >
              {ratingMeter.map((item) => (
                <i
                  key={item.toString()}
                  className={
                    rate > item || rate === item
                      ? 'fa fa-2x fa-star'
                      : 'fa fa-2x fa-star-o'
                  }
                  style={{ cursor: 'pointer', color: '#FFB300' }}
                  onClick={() => handleStar(item)}
                  aria-disabled={survey > 0 && businessType === 1}
                  aria-hidden='true'
                ></i>
              ))}
            </Col>
            <>
              {businessType === 0 &&
              dataForm.hasOwnProperty('surveyTitleHeaders') ? (
                <Col lg='12' md='12' sm='12' xs='12' className='mt-3'>
                  <Tabs id='surveyTitleHeaders'>
                    {dataFech.hasOwnProperty('surveyTitleHeaders') &&
                      dataFech.surveyTitleHeaders.map((item, index) => (
                        <Tab eventKey={index.toString()} title={item.title}>
                          {item.surveyTitleDetails.map((item) => (
                            <Form.Group
                              controlId={`formBasicCheckbox ${item.id}`}
                            >
                              <Form.Check
                                checked={
                                  dataFech.hasOwnProperty('surveyTitleIds')
                                    ? dataForm.surveyTitleIds !== null
                                      ? dataForm.surveyTitleIds.filter(
                                          (fi) => fi === item.id
                                        ).length > 0
                                        ? true
                                        : false
                                      : false
                                    : false
                                }
                                disabled={survey > 0 && businessType === 1}
                                type='checkbox'
                                name={item.id}
                                label={item.title}
                                onChange={handelValue}
                              />
                            </Form.Group>
                          ))}
                        </Tab>
                      ))}
                  </Tabs>
                </Col>
              ) : (
                <Space direction='vertical' style={{ width: '100%' }}>
                  <InputControlMulti
                    url={
                      type
                        ? `/discipline/dropdown/2?surveyType=${type}`
                        : '/discipline/dropdown/2'
                    }
                    label='موارد تشویقی'
                    name='positivePoints'
                    handelValue={(_, value) =>
                      setPointData({ ...pointData, positivePoints: value })
                    }
                  />
                  <InputControlMulti
                    url={
                      type
                        ? `/discipline/dropdown/1?surveyType=${type}`
                        : '/discipline/dropdown/1'
                    }
                    label='موارد تخلفی'
                    name='negativePoints'
                    handelValue={(_, value) =>
                      setPointData({ ...pointData, negativePoints: value })
                    }
                  />
                </Space>
              )}
            </>
            <Col lg='12' md='12' sm='12' xs='12' style={{ marginTop: '1rem' }}>
              <div className='form-group'>
                <label htmlFor='descriptionTextarea'>توضیحات</label>
                <textarea
                  disabled={survey > 0 && businessType === 1}
                  className='form-control'
                  id='surveyDescriptionُTextarea'
                  rows='6'
                  defaultValue={dataForm.description}
                  required
                  onChange={(e) =>
                    setDataForm({ ...dataForm, description: e.target.value })
                  }
                ></textarea>
              </div>
            </Col>
          </Row>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant='danger'
          disabled={submitIsLoading}
          onClick={handleCloseMoudal}
        >
          لغو
        </Button>
        <Button
          variant='success'
          disabled={submitIsLoading || (survey > 0 && businessType === 1)}
          onClick={handleSubmit}
        >
          {submitIsLoading ? (
            <i className='fa fa-spinner fa-pulse fa-fw'></i>
          ) : (
            'ثبت'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalUpdateSurvey;
